import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// atom — DWR stat chip: label smallcaps + value font-display. Pattern .stat-chip
// mockup (styles.css righe 563-572). Sfondo paper-deep + padding compatto.
// near-duplicate of future <Chip variant>: emergerà quando in PR 7/8 si toccano
// score-chip / meta-chip / spell-tag (composition principles §3.4). Per ora atom
// dedicato (1+5 istanze contenute nel ClassModal di PR 4).

interface StatChipProps {
  label: string;
  value: ReactNode;
  className?: string;
}

export function StatChip({ label, value, className }: StatChipProps) {
  return (
    <span
      className={cn(
        'bg-paper-deep inline-flex items-baseline gap-[0.4em] px-[0.7em] py-[0.3em] text-[0.85rem]',
        className,
      )}
    >
      <span className="font-display text-ink-soft text-[0.7rem] tracking-[0.08em] uppercase">
        {label}
      </span>
      <strong className="font-display text-[1rem] font-bold">{value}</strong>
    </span>
  );
}
